/** Red asterisk for mandatory form fields. */
export default function RequiredMark() {
  return (
    <span className="required-star" aria-hidden="true">
      *
    </span>
  );
}

/** Keeps label text and required asterisk on the same line inside column-flex forms. */
export function FieldLabel({ required, children, className = "" }) {
  const classes = ["field-label", className].filter(Boolean).join(" ");
  return (
    <span className={classes}>
      <span className="field-label__text">{children}</span>
      {required ? <RequiredMark /> : null}
    </span>
  );
}
